import { render, staticRenderFns } from "./TemplateImagem.vue?vue&type=template&id=25309d00&scoped=true&"
import script from "./TemplateImagem.vue?vue&type=script&lang=js&"
export * from "./TemplateImagem.vue?vue&type=script&lang=js&"
import style0 from "./TemplateImagem.vue?vue&type=style&index=0&id=25309d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25309d00",
  null
  
)

export default component.exports